/* SPLASHRIDE — garde-fous panier : 1) options (protection, prioritaire) supprimées s'il n'y a plus de veste ; 2) commande minimum 60 € */
(function(){
  if(window.__rsGuard) return; window.__rsGuard=true;
  var MAIN='splashride-veste-moto-reactive', MIN=6000, busy=false;
  var _fetch=window.fetch.bind(window); var T=window.RS_T||{}; var R=T.root||'/'; if(R.slice(-1)!=='/') R+='/';
  function toast(m){ var t=document.getElementById('rs-guard-toast'); if(!t){ t=document.createElement('div'); t.id='rs-guard-toast'; t.style.cssText='position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#111;color:#fff;padding:12px 18px;border-radius:8px;font:600 14px/1.3 system-ui,sans-serif;z-index:100000;max-width:90%;text-align:center;display:none'; document.body.appendChild(t);} t.textContent=m; t.style.display='block'; clearTimeout(t._h); t._h=setTimeout(function(){t.style.display='none'},3500); }
  function getCart(){ return _fetch(R+'cart.js',{cache:'no-store'}).then(function(r){return r.json()}); }
  function clean(){
    if(busy) return Promise.resolve(null); busy=true;
    return getCart().then(function(c){
      var hasMain=c.items.some(function(i){return i.handle===MAIN});
      if(!hasMain && c.items.length){
        var up={}; c.items.forEach(function(i){ up[i.key]=0; });
        return _fetch(R+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:up})}).then(function(r){return r.json()}).then(function(nc){
          busy=false;
          if(window.rsCart&&window.rsCart.refresh) window.rsCart.refresh();
          if(/\/cart\/?$/.test(location.pathname)) location.reload();
          return nc;
        });
      }
      busy=false; return c;
    }).catch(function(){ busy=false; return null; });
  }
  window.rsGuardClean=clean;
  /* après chaque modif du panier (retrait, quantité…), on vérifie */
  window.fetch=function(u,o){
    var p=_fetch(u,o); var url=(typeof u==='string'?u:(u&&u.url)||'');
    if(/\/cart\/(change|update)(\.js)?/.test(url)) p.then(function(){ setTimeout(clean,50); });
    return p;
  };
  /* blocage paiement sous 60 € */
  function guardCheckout(e){
    var el=e.target.closest&&e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [data-cd-btn], .shopify-payment-button button');
    var form=e.type==='submit'?e.target:null;
    if(!el && !(form && (form.action||'').indexOf('/cart')>-1 && (e.submitter&&e.submitter.name==='checkout'))) return;
    e.preventDefault(); e.stopImmediatePropagation();
    getCart().then(function(c){
      var hasMain=c.items.some(function(i){return i.handle===MAIN});
      if(!hasMain || c.total_price<MIN){ toast(T.min||'Commande minimum : 60 € (au moins une veste SPLASHRIDE).'); if(!hasMain) clean(); return; }
      location.href=R+'checkout';
    });
  }
  document.addEventListener('click',guardCheckout,true);
  document.addEventListener('submit',guardCheckout,true);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',clean); else clean();
})();
